import deleteAllCookies from './deleteAllCookies';

const signOut = async () => {
  try {
      localStorage.clear();
      deleteAllCookies();
  } catch(error) {
      console.log(error.message);
  }
  window.location.replace("https://login.stg.inbcu.com/login/logoff.jsp");
};

export default signOut;



// WEBPACK FOOTER //
// ./src/utils/signOut.js